"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var App_1 = require("../../../App");
var matrix_1 = require("./matrix");
var dialog_1 = require("../../dialog");
var MatrixDialog = function (props) { return (React.createElement(dialog_1.Dialog, { isOpen: props.show, onClose: function () { return App_1.store.risklist.evaluation.closeDialog(); }, contentLabel: props.data.matrix.risk_target_name },
    React.createElement(matrix_1.default, { data: props.data, evaluation_type: App_1.store.risklist.evaluation.eval_type }))); };
exports.default = MatrixDialog;
